/* SvoyDom — comportamente proprii peste Dawn.
   1. Paginarea numerotata inlocuita cu un buton care adauga produse
   2. Lightbox propriu de galerie: miniaturi, sageti, rotita, pinch

   Nu atinge niciun fisier Dawn: se agata de DOM-ul lui si isi remonteaza
   singur bucatile cand Dawn reincarca grila la filtrare sau sortare. */
(function () {
  'use strict';

  var T = window.SvoyDom || {};

  function t(key, vars) {
    var s = T[key] || '';
    for (var k in vars) s = s.replace('[' + k + ']', vars[k]);
    return s;
  }

  /* ================= 1. Load more ================= */

  var perPage = 0;

  function totalProducts() {
    var el = document.querySelector('.product-count__text, .product-count');
    if (!el) return 0;
    var m = (el.textContent || '').replace(/\s/g, '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }

  // Dawn eticheteaza AMBELE sageti cu `pagination__item--prev`, iar `aria-label`
  // e tradus, deci nu ne putem lua nici dupa clasa, nici dupa text. Singurul
  // lucru sigur e numarul: luam pagina curenta si cautam link-ul catre urmatoarea.
  function nextHref(wrap) {
    var cur = wrap.querySelector('.pagination__item--current');
    var n = parseInt((cur && cur.textContent || '1').trim(), 10) || 1;
    var links = [].slice.call(wrap.querySelectorAll('a.pagination__item[href]'));
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      var m = href.match(/[?&]page=(\d+)/);
      if (m && parseInt(m[1], 10) === n + 1) return href;
    }
    return null;
  }

  function buildLoadMore() {
    var grid = document.getElementById('product-grid');
    var wrap = document.querySelector('.pagination-wrapper');
    if (!grid || !wrap) return;
    if (wrap.querySelector('.sd-more')) return;   // deja montat

    if (!perPage) perPage = grid.children.length;

    // Clasa ascunde paginarea numerotata prin CSS. O punem din JS, nu din
    // stylesheet: fara JS omul trebuie sa ramana cu paginile lui Shopify,
    // iar crawlerul le vede oricum, sunt in DOM.
    wrap.classList.add('sd-paginated');

    var box = document.createElement('div');
    box.className = 'sd-more';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sd-btn sd-more__btn';
    var info = document.createElement('p');
    info.className = 'sd-more__info';
    box.appendChild(btn);
    box.appendChild(info);
    wrap.appendChild(box);

    function refresh() {
      var shown = grid.children.length;
      var total = totalProducts();
      var href = nextHref(wrap);
      info.textContent = total ? t('shown', { shown: shown, total: total }) : '';
      if (!href) {
        btn.hidden = true;
        info.textContent = t('done');
        return;
      }
      btn.hidden = false;
      btn.disabled = false;
      var left = total ? total - shown : perPage;
      btn.textContent = t('more', { count: Math.min(perPage || 24, left) });
    }

    btn.addEventListener('click', function () {
      var href = nextHref(wrap);
      if (!href) return;
      btn.disabled = true;
      btn.textContent = t('loading');

      fetch(href)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('product-grid');
          if (fresh) {
            var items = [].slice.call(fresh.children);
            perPage = items.length || perPage;
            items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
          }
          // Inlocuim paginarea cu cea din pagina proaspata, ca sa avem
          // link-ul "urmatoarea" actualizat. Butonul se remonteaza singur.
          var freshWrap = doc.querySelector('.pagination-wrapper');
          var old = wrap.querySelector('.sd-more');
          if (old) old.remove();
          wrap.innerHTML = freshWrap ? freshWrap.innerHTML : '';
          // URL-ul urmeaza continutul, ca reincarcarea sa cada in acelasi loc
          try { history.replaceState({}, '', href); } catch (e) {}
          buildLoadMore();
        })
        .catch(function () {
          btn.disabled = false;
          refresh();
        });
    });

    refresh();
  }

  function watchGrid() {
    var host = document.getElementById('ProductGridContainer');
    if (!host) return;
    buildLoadMore();
    // Dawn rescrie tot containerul cand se schimba filtrele sau sortarea.
    // buildLoadMore() iese imediat daca butonul e deja acolo, deci observatorul
    // nu se autodeclanseaza la nesfarsit.
    new MutationObserver(function () { perPage = 0; buildLoadMore(); })
      .observe(host, { childList: true, subtree: true });
  }

  /* ================= 2. Lightbox de galerie =================
     Inlocuieste modalul lui Dawn pe TOATE latimile. Al lui punea poza la marimea
     ei reala intr-o fereastra cu scroll: pe telefon aterizai in mijlocul unei
     imagini de 1100px, pe desktop nu aveai nici rotita, nici miniaturi. */

  var MAX = 5, MIN = 1;

  function srcAt(img, w) {
    var src = img.currentSrc || img.src || '';
    if (!src) return '';
    return src.replace(/([?&])width=\d+/, '$1width=' + w);
  }

  function galleryImages() {
    return [].slice.call(document.querySelectorAll('.product__media-list li img'));
  }

  var zoom = null;

  function buildZoom() {
    if (zoom) return zoom;

    var root = document.createElement('div');
    root.className = 'sd-zoom';
    root.hidden = true;
    root.innerHTML =
      '<div class="sd-zoom__counter"></div>' +
      '<button type="button" class="sd-zoom__close" aria-label="' + (T.close || 'Close') + '">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" ' +
        'stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>' +
      '<div class="sd-zoom__body">' +
        '<div class="sd-zoom__rail"></div>' +
        '<div class="sd-zoom__main">' +
          '<button type="button" class="sd-zoom__nav sd-zoom__nav--prev" aria-label="&#8592;">' +
            '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" ' +
            'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 4L7 12l8 8"/></svg>' +
          '</button>' +
          '<div class="sd-zoom__stage"><img class="sd-zoom__img" alt=""></div>' +
          '<button type="button" class="sd-zoom__nav sd-zoom__nav--next" aria-label="&#8594;">' +
            '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" ' +
            'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4l8 8-8 8"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>' +
      '<div class="sd-zoom__tools">' +
        '<button type="button" class="sd-zoom__tool" data-act="in" aria-label="+">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
          'stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>' +
        '</button>' +
        '<button type="button" class="sd-zoom__tool" data-act="out" aria-label="&#8722;">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
          'stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>' +
        '</button>' +
        '<button type="button" class="sd-zoom__tool" data-act="reset" aria-label="1:1">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
          'stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>' +
        '</button>' +
      '</div>' +
      // doua indicii, unul pentru deget si unul pentru rotita; le comuta CSS-ul
      '<p class="sd-zoom__hint">' +
        '<span class="sd-zoom__hint--touch">' + (T.hint || '') + '</span>' +
        '<span class="sd-zoom__hint--mouse">' + (T.hintWheel || '') + '</span>' +
      '</p>';
    document.body.appendChild(root);

    var stage = root.querySelector('.sd-zoom__stage');
    var img = root.querySelector('.sd-zoom__img');
    var rail = root.querySelector('.sd-zoom__rail');
    var counter = root.querySelector('.sd-zoom__counter');

    var srcs = [], thumbs = [], index = 0;
    var scale = 1, tx = 0, ty = 0;
    var pointers = new Map();
    var start = null;
    var lastTap = 0;

    function apply() {
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      root.classList.toggle('is-zoomed', scale > 1.01);
    }

    // Cat poate aluneca imaginea fara sa intre gol in cadru. `offsetWidth` e
    // marimea din layout, neatinsa de transform — `getBoundingClientRect` ar
    // intoarce-o deja scalata si am inmulti de doua ori.
    function clampPan() {
      var maxX = Math.max(0, (img.offsetWidth * scale - stage.clientWidth) / 2);
      var maxY = Math.max(0, (img.offsetHeight * scale - stage.clientHeight) / 2);
      tx = Math.min(maxX, Math.max(-maxX, tx));
      ty = Math.min(maxY, Math.max(-maxY, ty));
    }

    // Mareste pastrand pe loc punctul (cx, cy), masurat fata de centrul scenei.
    // Fara ancora, zoom-ul cu rotita ar fugi mereu spre centru, iar pinch-ul
    // ar sari sub degete.
    function zoomTo(next, cx, cy) {
      next = Math.min(MAX, Math.max(MIN, next));
      var k = next / scale;
      tx = cx - (cx - tx) * k;
      ty = cy - (cy - ty) * k;
      scale = next;
      clampPan();
      apply();
    }

    function reset() { scale = 1; tx = 0; ty = 0; apply(); }

    function markRail() {
      [].slice.call(rail.children).forEach(function (b, i) {
        b.classList.toggle('is-active', i === index);
        if (i === index && b.scrollIntoView) {
          b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    }

    function show(i) {
      index = (i + srcs.length) % srcs.length;
      img.src = srcs[index];
      counter.textContent = srcs.length > 1
        ? t('counter', { index: index + 1, total: srcs.length }) : '';
      markRail();
      reset();
    }

    function buildRail() {
      rail.innerHTML = '';
      root.classList.toggle('has-rail', srcs.length > 1);
      root.classList.toggle('has-nav', srcs.length > 1);
      if (srcs.length < 2) return;
      thumbs.forEach(function (src, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sd-zoom__thumb';
        b.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
        b.addEventListener('click', function () { show(i); });
        rail.appendChild(b);
      });
    }

    function open(list, thumbList, i) {
      srcs = list;
      thumbs = thumbList;
      root.hidden = false;
      document.documentElement.classList.add('sd-zoom-open');
      buildRail();
      show(i);
    }

    function close() {
      root.hidden = true;
      document.documentElement.classList.remove('sd-zoom-open');
      reset();
    }

    root.querySelector('.sd-zoom__close').addEventListener('click', close);
    root.querySelector('.sd-zoom__nav--prev').addEventListener('click', function () { show(index - 1); });
    root.querySelector('.sd-zoom__nav--next').addEventListener('click', function () { show(index + 1); });

    root.querySelector('.sd-zoom__tools').addEventListener('click', function (e) {
      var b = e.target.closest('.sd-zoom__tool');
      if (!b) return;
      var act = b.dataset.act;
      if (act === 'reset') reset();
      else zoomTo(act === 'in' ? scale * 1.4 : scale / 1.4, 0, 0);
    });

    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') show(index + 1);
      if (e.key === 'ArrowLeft') show(index - 1);
    });

    // rotita: zoom ancorat pe cursor, nu scroll de pagina
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var b = stage.getBoundingClientRect();
      zoomTo(scale * (e.deltaY < 0 ? 1.18 : 1 / 1.18),
             e.clientX - (b.left + b.width / 2),
             e.clientY - (b.top + b.height / 2));
    }, { passive: false });

    // dublu-clic pe desktop; pe touch se ocupa release() de dublu-tap
    stage.addEventListener('dblclick', function (e) {
      var b = stage.getBoundingClientRect();
      if (scale > 1.01) reset();
      else zoomTo(2.5, e.clientX - (b.left + b.width / 2), e.clientY - (b.top + b.height / 2));
    });

    function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    function toStage(p) {
      var b = stage.getBoundingClientRect();
      return { x: p.x - (b.left + b.width / 2), y: p.y - (b.top + b.height / 2) };
    }

    stage.addEventListener('pointerdown', function (e) {
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      var pts = Array.from(pointers.values());
      if (pts.length === 2) {
        var c = mid(pts[0], pts[1]);
        start = { d: dist(pts[0], pts[1]), s: scale, c: toStage(c), raw: c, tx: tx, ty: ty };
      } else if (pts.length === 1) {
        start = { x: e.clientX, y: e.clientY, tx: tx, ty: ty, s: scale };
      }
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      var pts = Array.from(pointers.values());

      if (pts.length === 2 && start && start.d) {
        var now = mid(pts[0], pts[1]);
        var next = Math.min(MAX, Math.max(MIN, start.s * (dist(pts[0], pts[1]) / start.d)));
        var k = next / start.s;
        // ancorat pe punctul dintre degete la inceputul gestului, plus cat s-au
        // mutat degetele intre timp
        tx = start.c.x - (start.c.x - start.tx) * k + (now.x - start.raw.x);
        ty = start.c.y - (start.c.y - start.ty) * k + (now.y - start.raw.y);
        scale = next;
        clampPan();
        apply();
      } else if (pts.length === 1 && start && scale > 1.01) {
        tx = start.tx + (e.clientX - start.x);
        ty = start.ty + (e.clientY - start.y);
        clampPan();
        apply();
      }
    });

    function release(e) {
      pointers.delete(e.pointerId);
      if (pointers.size > 0 || !start) { if (pointers.size === 0) start = null; return; }

      var moved = start.x != null &&
        Math.hypot(e.clientX - start.x, e.clientY - start.y) > 12;
      var now = Date.now();

      if (!moved && start.x != null && e.pointerType !== 'mouse') {
        // doua atingeri apropiate = zoom sau revenire (mouse-ul are dblclick)
        if (now - lastTap < 300) {
          if (scale > 1.01) reset();
          else zoomTo(2.5, 0, 0);
          lastTap = 0;
        } else {
          lastTap = now;
        }
      } else if (moved && scale <= 1.01 && srcs.length > 1) {
        // glisare orizontala intre poze, doar cand nu e marita
        var dx = e.clientX - start.x;
        if (Math.abs(dx) > 60) show(index + (dx < 0 ? 1 : -1));
      }
      start = null;
    }

    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);

    zoom = { open: open, close: close };
    return zoom;
  }

  function initZoom() {
    var list = document.querySelector('.product__media-list');
    if (!list) return;

    // Capturam inaintea lui Dawn si ii oprim modalul: al nostru are miniaturi,
    // rotita si pinch, al lui n-are niciunul.
    list.addEventListener('click', function (e) {
      var li = e.target.closest('li');
      if (!li) return;
      var img = li.querySelector('img');
      if (!img) return;
      e.preventDefault();
      e.stopPropagation();
      var imgs = galleryImages();
      buildZoom().open(
        imgs.map(function (i) { return srcAt(i, 1600); }),
        imgs.map(function (i) { return srcAt(i, 200); }),
        imgs.indexOf(img)
      );
    }, true);
  }

  function boot() { watchGrid(); initZoom(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
